/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import GoogleMapReact from 'google-map-react';
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { CS } from '../constants/botTypes';
import { DataContext } from '../contexts/DataContext';
import { updateGoogleMapA11yAttributes } from '../utils/a11y-helpers';
import MapMarker from './MapMarker';

const GoogleMap = ({ botType, locations, flowIdentifier }) => {
  const [canRender, setCanRender] = useState(true);
  const [center, setCenter] = useState({ lat: 0, lng: 0 });

  const { currentFlowIdentifier, setSelectedLocationIndex } = useContext(DataContext);

  useEffect(() => {
    if (flowIdentifier !== currentFlowIdentifier) {
      setCanRender(false);
      setSelectedLocationIndex(null);
    }
  }, [currentFlowIdentifier]);

  const mapOptions = () => {
    return {
      clickableIcons: false,
      controlSize: 24,
      fullscreenControl: false,
      minZoom: 8,
      maxZoom: 16,
      rotateControl: false,
      tiltControl: false
    };
  };

  useLayoutEffect(() => {
    setCenter({ lat: locations[0].lat, lng: locations[0].lng });
    updateGoogleMapA11yAttributes();
  }, []);

  const renderMarkers = () => {
    if (botType === CS) {
      return locations.map((location, i) => {
        const { lat, lng } = location;
        return (
          <MapMarker
            key={i}
            lat={lat}
            lng={lng}
            locationIndex={i}
            totalMarkerCount={locations.length}
            resetMapCenter={resetMapCenter}
          />
        );
      });
    }
  };

  const resetMapCenter = selectedLocationIndex => {
    const { lat, lng } = locations[selectedLocationIndex];
    setCenter({ lat, lng });
  };

  return canRender ? (
    <div style={{ height: '40vh', width: '100%' }}>
      <GoogleMapReact
        options={mapOptions}
        bootstrapURLKeys={{
          key:
            process.env.REACT_APP_ENV === 'prod'
              ? process.env.REACT_APP_GOOGLE_MAPS_PROD_API_KEY
              : process.env.REACT_APP_GOOGLE_MAPS_NON_PROD_API_KEY
        }}
        center={center}
        defaultZoom={11}
      >
        {renderMarkers()}
      </GoogleMapReact>
    </div>
  ) : null;
};

export default React.memo(GoogleMap);
